import { faStoreAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Button from "../../Components/Button/Button";
import Input from "../../Components/Input/Input";
import Timer from "../../Components/Timer/Timer";
import Style from "./Login.module.css";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import {
  SupplierCheckCodeAPI,
  SupplierLoginPhoneNumber,
} from "../../Api/SupplierServices";
import { useHistory } from "react-router-dom";
import LoadingComponet from "../../Components/LoadingComponet/LoadingComponet";

const ConfirmCode = (props) => {
  const history = useHistory("");
  const [code, setCode] = useState();
  const [resend, setResend] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(props.location.state);
  const [remainTime, setReaminTime] = useState("");
  const [load, setLoad] = useState(false);
  useEffect(() => {
    getCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCode = () => {
    setLoad(true);
    let info = {
      phone: phoneNumber,
    };
    SupplierLoginPhoneNumber(info, (state,succ) => {
      setLoad(false);
      if(state){
if (succ.status === 1) {
        succToast(succ.message);
        setReaminTime(succ.remaining_time);
        setResend(false);
        setPhoneNumber(succ.phone);
        setTimeout(
          () => setResend(true),
          parseInt(`${succ.remaining_time}000`)
        );
      } else if (
        succ.message === "شماره وارد شده اشتباه است!" ||
        succ.message === "حسابی با این شماره یافت نشد!"||
        succ.message === "حساب کاربری شما مسدود می‌باشد."
      ) {
        errorToast(succ.message);
        setTimeout(() => history.push("./login"), 1000);
      } else {
        errorToast(succ.message);
        setReaminTime(succ.remaining_time);
        setPhoneNumber(succ.phone);
        setTimeout(
          () => setResend(true),
          parseInt(`${succ.remaining_time}000`)
        );
      }
      }else{
        errorToast("لطفا وضعیت اینترنت خود را بررسی کنید و دوباره تست کنید!")
        setTimeout(() => history.push("./login"), 1000);
      }
      
    });
  };
  const CheckCodeHandler = async (e) => {
    e.preventDefault();
    if (code === "") errorToast("لطفا کد را وارد کنید!");
    else {
      let info = {
        code: code,
        phone: phoneNumber,
      };
      SupplierCheckCodeAPI(info, (succ) => {
        if (succ.status === 1) {
          succToast(succ.message);
          localStorage.setItem("JwtTokens", succ.token);
          localStorage.setItem("type", succ.type);
          setTimeout(() => history.push("./"));
        } else {
          errorToast(succ.message);
          setPhoneNumber(succ.phone);
          setReaminTime(succ.remaining_time);
          setTimeout(
            () => setResend(true),
            parseInt(`${succ.remaining_time}000`)
          );
          setTimeout(() => history.push("./login"), 1000);
        }
      });
    }
  };

  let loading = null;

  if (load === true) {
    loading = <LoadingComponet />;
  } else {
    loading = (
      <form className={Style.formHolder}>
        <FontAwesomeIcon icon={faStoreAlt} />
        <p>:کد دریافتی را وارد کنید</p>
        <Input
          inputtype={"text"}
          placeholder="کد دریافتی"
          pattern="\d*"
          maxLength="6"
          style={{ textAlign: "center" ,color:"gray"}}
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />

        {resend ? (
          <p className={Style.resend} onClick={getCode}>
            ارسال دوباره
          </p>
        ) : (
          <Timer Time={remainTime} />
        )}
        <div className={Style.BtnHolder}>
          <Button
            Value={"تایید"}
            ClassBtn={"confirmBtn"}
            ClickHandler={CheckCodeHandler}
          />
        </div>
      </form>
    );
  }
  return (
    <div className={Style.pageHolder}>
      <div className={Style.ImageHolder}>
        <img src="/Assets/Images/Auth/contract.jpg" alt="barest" />
      </div>
      {loading}
    </div>
  );
};

export default ConfirmCode;
